module.exports = __webpack_public_path__ + "img/burshtat_b2b_portfolio_3_mob.ca3a6e31.png";